<template>
  <div></div>
</template>

<script>
import usuariosService from "@/services/UsuariosService";

export default {
  mounted() {
    usuariosService.obtenerDatosPersonalesPorToken(this.$route.query.token, response => {
      if (response.data.resultado === "OK") {
        this.$store.commit("obtenerDatosPersonalesExternoExito", { ...response.data, token: this.$route.query.token });
        this.$router.push("/actualizacionExterna/actualizar");
      } else {
        // commit("obtenerDatosPersonalesExternoError", response.data.mensaje);
      }
    });
  }
};
</script>
